var cov_1g45y1vbft = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Sticky/index.tsx",
      hash = "f8530dc83fdb27a59aceb6ba0ddb31dd49a3beec",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Sticky/index.tsx",
    statementMap: {
      "0": {
        start: {
          line: 12,
          column: 15
        },
        end: {
          line: 12,
          column: 45
        }
      },
      "1": {
        start: {
          line: 13,
          column: 22
        },
        end: {
          line: 13,
          column: 54
        }
      },
      "2": {
        start: {
          line: 14,
          column: 22
        },
        end: {
          line: 14,
          column: 25
        }
      },
      "3": {
        start: {
          line: 15,
          column: 21
        },
        end: {
          line: 18,
          column: 1
        }
      },
      "4": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 49,
          column: 16
        }
      },
      "5": {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 51,
          column: 19
        }
      },
      "6": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 53,
          column: 50
        }
      },
      "7": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 54,
          column: 48
        }
      },
      "8": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 55,
          column: 58
        }
      },
      "9": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 56,
          column: 56
        }
      },
      "10": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 57,
          column: 19
        }
      },
      "11": {
        start: {
          line: 61,
          column: 4
        },
        end: {
          line: 61,
          column: 29
        }
      },
      "12": {
        start: {
          line: 62,
          column: 23
        },
        end: {
          line: 62,
          column: 33
        }
      },
      "13": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 63,
          column: 56
        }
      },
      "14": {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 64,
          column: 25
        }
      },
      "15": {
        start: {
          line: 66,
          column: 4
        },
        end: {
          line: 68,
          column: 5
        }
      },
      "16": {
        start: {
          line: 67,
          column: 6
        },
        end: {
          line: 67,
          column: 23
        }
      },
      "17": {
        start: {
          line: 72,
          column: 4
        },
        end: {
          line: 74,
          column: 5
        }
      },
      "18": {
        start: {
          line: 73,
          column: 6
        },
        end: {
          line: 73,
          column: 24
        }
      },
      "19": {
        start: {
          line: 78,
          column: 4
        },
        end: {
          line: 78,
          column: 32
        }
      },
      "20": {
        start: {
          line: 79,
          column: 4
        },
        end: {
          line: 79,
          column: 23
        }
      },
      "21": {
        start: {
          line: 80,
          column: 4
        },
        end: {
          line: 80,
          column: 56
        }
      },
      "22": {
        start: {
          line: 80,
          column: 26
        },
        end: {
          line: 80,
          column: 56
        }
      },
      "23": {
        start: {
          line: 84,
          column: 20
        },
        end: {
          line: 84,
          column: 30
        }
      },
      "24": {
        start: {
          line: 85,
          column: 4
        },
        end: {
          line: 87,
          column: 5
        }
      },
      "25": {
        start: {
          line: 86,
          column: 6
        },
        end: {
          line: 86,
          column: 17
        }
      },
      "26": {
        start: {
          line: 88,
          column: 4
        },
        end: {
          line: 88,
          column: 16
        }
      },
      "27": {
        start: {
          line: 92,
          column: 29
        },
        end: {
          line: 92,
          column: 46
        }
      },
      "28": {
        start: {
          line: 93,
          column: 20
        },
        end: {
          line: 93,
          column: 30
        }
      },
      "29": {
        start: {
          line: 95,
          column: 39
        },
        end: {
          line: 101,
          column: 5
        }
      },
      "30": {
        start: {
          line: 102,
          column: 4
        },
        end: {
          line: 114,
          column: 5
        }
      },
      "31": {
        start: {
          line: 103,
          column: 6
        },
        end: {
          line: 113,
          column: 7
        }
      },
      "32": {
        start: {
          line: 104,
          column: 8
        },
        end: {
          line: 104,
          column: 33
        }
      },
      "33": {
        start: {
          line: 106,
          column: 8
        },
        end: {
          line: 106,
          column: 35
        }
      },
      "34": {
        start: {
          line: 107,
          column: 8
        },
        end: {
          line: 111,
          column: 9
        }
      },
      "35": {
        start: {
          line: 108,
          column: 10
        },
        end: {
          line: 108,
          column: 84
        }
      },
      "36": {
        start: {
          line: 110,
          column: 10
        },
        end: {
          line: 110,
          column: 75
        }
      },
      "37": {
        start: {
          line: 112,
          column: 8
        },
        end: {
          line: 112,
          column: 25
        }
      },
      "38": {
        start: {
          line: 116,
          column: 4
        },
        end: {
          line: 116,
          column: 35
        }
      },
      "39": {
        start: {
          line: 118,
          column: 4
        },
        end: {
          line: 118,
          column: 16
        }
      },
      "40": {
        start: {
          line: 122,
          column: 59
        },
        end: {
          line: 122,
          column: 69
        }
      },
      "41": {
        start: {
          line: 123,
          column: 34
        },
        end: {
          line: 123,
          column: 44
        }
      },
      "42": {
        start: {
          line: 125,
          column: 4
        },
        end: {
          line: 125,
          column: 42
        }
      },
      "43": {
        start: {
          line: 125,
          column: 36
        },
        end: {
          line: 125,
          column: 42
        }
      },
      "44": {
        start: {
          line: 127,
          column: 21
        },
        end: {
          line: 127,
          column: 57
        }
      },
      "45": {
        start: {
          line: 129,
          column: 4
        },
        end: {
          line: 129,
          column: 33
        }
      },
      "46": {
        start: {
          line: 129,
          column: 27
        },
        end: {
          line: 129,
          column: 33
        }
      },
      "47": {
        start: {
          line: 131,
          column: 4
        },
        end: {
          line: 131,
          column: 73
        }
      },
      "48": {
        start: {
          line: 131,
          column: 67
        },
        end: {
          line: 131,
          column: 73
        }
      },
      "49": {
        start: {
          line: 133,
          column: 40
        },
        end: {
          line: 133,
          column: 70
        }
      },
      "50": {
        start: {
          line: 134,
          column: 4
        },
        end: {
          line: 134,
          column: 71
        }
      },
      "51": {
        start: {
          line: 135,
          column: 26
        },
        end: {
          line: 135,
          column: 61
        }
      },
      "52": {
        start: {
          line: 136,
          column: 23
        },
        end: {
          line: 136,
          column: 60
        }
      },
      "53": {
        start: {
          line: 138,
          column: 28
        },
        end: {
          line: 138,
          column: 94
        }
      },
      "54": {
        start: {
          line: 139,
          column: 23
        },
        end: {
          line: 139,
          column: 37
        }
      },
      "55": {
        start: {
          line: 141,
          column: 4
        },
        end: {
          line: 145,
          column: 5
        }
      },
      "56": {
        start: {
          line: 142,
          column: 24
        },
        end: {
          line: 142,
          column: 59
        }
      },
      "57": {
        start: {
          line: 143,
          column: 6
        },
        end: {
          line: 143,
          column: 28
        }
      },
      "58": {
        start: {
          line: 144,
          column: 6
        },
        end: {
          line: 144,
          column: 56
        }
      },
      "59": {
        start: {
          line: 144,
          column: 27
        },
        end: {
          line: 144,
          column: 56
        }
      },
      "60": {
        start: {
          line: 147,
          column: 29
        },
        end: {
          line: 151,
          column: 5
        }
      },
      "61": {
        start: {
          line: 156,
          column: 4
        },
        end: {
          line: 184,
          column: 5
        }
      },
      "62": {
        start: {
          line: 157,
          column: 21
        },
        end: {
          line: 157,
          column: 24
        }
      },
      "63": {
        start: {
          line: 158,
          column: 6
        },
        end: {
          line: 161,
          column: 7
        }
      },
      "64": {
        start: {
          line: 159,
          column: 31
        },
        end: {
          line: 159,
          column: 62
        }
      },
      "65": {
        start: {
          line: 160,
          column: 8
        },
        end: {
          line: 160,
          column: 61
        }
      },
      "66": {
        start: {
          line: 162,
          column: 6
        },
        end: {
          line: 183,
          column: 7
        }
      },
      "67": {
        start: {
          line: 163,
          column: 8
        },
        end: {
          line: 163,
          column: 69
        }
      },
      "68": {
        start: {
          line: 164,
          column: 8
        },
        end: {
          line: 164,
          column: 72
        }
      },
      "69": {
        start: {
          line: 165,
          column: 8
        },
        end: {
          line: 165,
          column: 38
        }
      },
      "70": {
        start: {
          line: 166,
          column: 13
        },
        end: {
          line: 183,
          column: 7
        }
      },
      "71": {
        start: {
          line: 167,
          column: 8
        },
        end: {
          line: 169,
          column: 9
        }
      },
      "72": {
        start: {
          line: 168,
          column: 10
        },
        end: {
          line: 168,
          column: 76
        }
      },
      "73": {
        start: {
          line: 170,
          column: 8
        },
        end: {
          line: 175,
          column: 9
        }
      },
      "74": {
        start: {
          line: 171,
          column: 10
        },
        end: {
          line: 171,
          column: 37
        }
      },
      "75": {
        start: {
          line: 172,
          column: 10
        },
        end: {
          line: 172,
          column: 20
        }
      },
      "76": {
        start: {
          line: 173,
          column: 10
        },
        end: {
          line: 173,
          column: 28
        }
      },
      "77": {
        start: {
          line: 174,
          column: 10
        },
        end: {
          line: 174,
          column: 42
        }
      },
      "78": {
        start: {
          line: 176,
          column: 13
        },
        end: {
          line: 183,
          column: 7
        }
      },
      "79": {
        start: {
          line: 177,
          column: 8
        },
        end: {
          line: 177,
          column: 72
        }
      },
      "80": {
        start: {
          line: 178,
          column: 8
        },
        end: {
          line: 178,
          column: 38
        }
      },
      "81": {
        start: {
          line: 179,
          column: 13
        },
        end: {
          line: 183,
          column: 7
        }
      },
      "82": {
        start: {
          line: 180,
          column: 8
        },
        end: {
          line: 180,
          column: 69
        }
      },
      "83": {
        start: {
          line: 181,
          column: 8
        },
        end: {
          line: 181,
          column: 86
        }
      },
      "84": {
        start: {
          line: 182,
          column: 8
        },
        end: {
          line: 182,
          column: 38
        }
      },
      "85": {
        start: {
          line: 186,
          column: 4
        },
        end: {
          line: 219,
          column: 5
        }
      },
      "86": {
        start: {
          line: 187,
          column: 24
        },
        end: {
          line: 187,
          column: 43
        }
      },
      "87": {
        start: {
          line: 189,
          column: 6
        },
        end: {
          line: 192,
          column: 7
        }
      },
      "88": {
        start: {
          line: 190,
          column: 34
        },
        end: {
          line: 190,
          column: 65
        }
      },
      "89": {
        start: {
          line: 191,
          column: 8
        },
        end: {
          line: 191,
          column: 79
        }
      },
      "90": {
        start: {
          line: 194,
          column: 6
        },
        end: {
          line: 218,
          column: 7
        }
      },
      "91": {
        start: {
          line: 195,
          column: 8
        },
        end: {
          line: 195,
          column: 72
        }
      },
      "92": {
        start: {
          line: 196,
          column: 8
        },
        end: {
          line: 196,
          column: 78
        }
      },
      "93": {
        start: {
          line: 197,
          column: 8
        },
        end: {
          line: 197,
          column: 38
        }
      },
      "94": {
        start: {
          line: 198,
          column: 13
        },
        end: {
          line: 218,
          column: 7
        }
      },
      "95": {
        start: {
          line: 202,
          column: 8
        },
        end: {
          line: 204,
          column: 9
        }
      },
      "96": {
        start: {
          line: 203,
          column: 10
        },
        end: {
          line: 203,
          column: 82
        }
      },
      "97": {
        start: {
          line: 205,
          column: 8
        },
        end: {
          line: 210,
          column: 9
        }
      },
      "98": {
        start: {
          line: 206,
          column: 10
        },
        end: {
          line: 206,
          column: 37
        }
      },
      "99": {
        start: {
          line: 207,
          column: 10
        },
        end: {
          line: 207,
          column: 20
        }
      },
      "100": {
        start: {
          line: 208,
          column: 10
        },
        end: {
          line: 208,
          column: 28
        }
      },
      "101": {
        start: {
          line: 209,
          column: 10
        },
        end: {
          line: 209,
          column: 42
        }
      },
      "102": {
        start: {
          line: 211,
          column: 13
        },
        end: {
          line: 218,
          column: 7
        }
      },
      "103": {
        start: {
          line: 212,
          column: 8
        },
        end: {
          line: 212,
          column: 78
        }
      },
      "104": {
        start: {
          line: 213,
          column: 8
        },
        end: {
          line: 213,
          column: 38
        }
      },
      "105": {
        start: {
          line: 214,
          column: 13
        },
        end: {
          line: 218,
          column: 7
        }
      },
      "106": {
        start: {
          line: 215,
          column: 8
        },
        end: {
          line: 215,
          column: 72
        }
      },
      "107": {
        start: {
          line: 216,
          column: 8
        },
        end: {
          line: 216,
          column: 92
        }
      },
      "108": {
        start: {
          line: 217,
          column: 8
        },
        end: {
          line: 217,
          column: 38
        }
      },
      "109": {
        start: {
          line: 221,
          column: 4
        },
        end: {
          line: 223,
          column: 5
        }
      },
      "110": {
        start: {
          line: 222,
          column: 6
        },
        end: {
          line: 222,
          column: 36
        }
      },
      "111": {
        start: {
          line: 225,
          column: 4
        },
        end: {
          line: 228,
          column: 5
        }
      },
      "112": {
        start: {
          line: 226,
          column: 6
        },
        end: {
          line: 226,
          column: 47
        }
      },
      "113": {
        start: {
          line: 227,
          column: 6
        },
        end: {
          line: 227,
          column: 30
        }
      },
      "114": {
        start: {
          line: 232,
          column: 25
        },
        end: {
          line: 232,
          column: 35
        }
      },
      "115": {
        start: {
          line: 233,
          column: 4
        },
        end: {
          line: 233,
          column: 54
        }
      },
      "116": {
        start: {
          line: 233,
          column: 48
        },
        end: {
          line: 233,
          column: 54
        }
      },
      "117": {
        start: {
          line: 234,
          column: 4
        },
        end: {
          line: 234,
          column: 54
        }
      },
      "118": {
        start: {
          line: 234,
          column: 40
        },
        end: {
          line: 234,
          column: 54
        }
      },
      "119": {
        start: {
          line: 238,
          column: 20
        },
        end: {
          line: 238,
          column: 30
        }
      },
      "120": {
        start: {
          line: 239,
          column: 4
        },
        end: {
          line: 242,
          column: 5
        }
      },
      "121": {
        start: {
          line: 240,
          column: 6
        },
        end: {
          line: 240,
          column: 27
        }
      },
      "122": {
        start: {
          line: 241,
          column: 6
        },
        end: {
          line: 241,
          column: 12
        }
      },
      "123": {
        start: {
          line: 244,
          column: 4
        },
        end: {
          line: 244,
          column: 22
        }
      },
      "124": {
        start: {
          line: 245,
          column: 4
        },
        end: {
          line: 245,
          column: 24
        }
      },
      "125": {
        start: {
          line: 246,
          column: 4
        },
        end: {
          line: 246,
          column: 22
        }
      },
      "126": {
        start: {
          line: 247,
          column: 4
        },
        end: {
          line: 252,
          column: 10
        }
      },
      "127": {
        start: {
          line: 248,
          column: 6
        },
        end: {
          line: 248,
          column: 25
        }
      },
      "128": {
        start: {
          line: 249,
          column: 6
        },
        end: {
          line: 251,
          column: 7
        }
      },
      "129": {
        start: {
          line: 250,
          column: 8
        },
        end: {
          line: 250,
          column: 29
        }
      },
      "130": {
        start: {
          line: 256,
          column: 4
        },
        end: {
          line: 256,
          column: 21
        }
      },
      "131": {
        start: {
          line: 260,
          column: 4
        },
        end: {
          line: 260,
          column: 20
        }
      },
      "132": {
        start: {
          line: 264,
          column: 4
        },
        end: {
          line: 264,
          column: 25
        }
      },
      "133": {
        start: {
          line: 268,
          column: 4
        },
        end: {
          line: 274,
          column: 5
        }
      },
      "134": {
        start: {
          line: 269,
          column: 6
        },
        end: {
          line: 269,
          column: 86
        }
      },
      "135": {
        start: {
          line: 271,
          column: 6
        },
        end: {
          line: 273,
          column: 8
        }
      },
      "136": {
        start: {
          line: 272,
          column: 8
        },
        end: {
          line: 272,
          column: 55
        }
      },
      "137": {
        start: {
          line: 275,
          column: 4
        },
        end: {
          line: 275,
          column: 58
        }
      },
      "138": {
        start: {
          line: 279,
          column: 4
        },
        end: {
          line: 285,
          column: 5
        }
      },
      "139": {
        start: {
          line: 280,
          column: 6
        },
        end: {
          line: 280,
          column: 75
        }
      },
      "140": {
        start: {
          line: 282,
          column: 6
        },
        end: {
          line: 284,
          column: 8
        }
      },
      "141": {
        start: {
          line: 283,
          column: 8
        },
        end: {
          line: 283,
          column: 58
        }
      },
      "142": {
        start: {
          line: 286,
          column: 4
        },
        end: {
          line: 286,
          column: 61
        }
      },
      "143": {
        start: {
          line: 290,
          column: 62
        },
        end: {
          line: 290,
          column: 72
        }
      },
      "144": {
        start: {
          line: 291,
          column: 28
        },
        end: {
          line: 291,
          column: 38
        }
      },
      "145": {
        start: {
          line: 293,
          column: 21
        },
        end: {
          line: 293,
          column: 37
        }
      },
      "146": {
        start: {
          line: 294,
          column: 21
        },
        end: {
          line: 294,
          column: 37
        }
      },
      "147": {
        start: {
          line: 296,
          column: 4
        },
        end: {
          line: 299,
          column: 5
        }
      },
      "148": {
        start: {
          line: 297,
          column: 6
        },
        end: {
          line: 297,
          column: 108
        }
      },
      "149": {
        start: {
          line: 298,
          column: 6
        },
        end: {
          line: 298,
          column: 21
        }
      },
      "150": {
        start: {
          line: 301,
          column: 4
        },
        end: {
          line: 309,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 48,
            column: 2
          },
          end: {
            line: 48,
            column: 3
          }
        },
        loc: {
          start: {
            line: 48,
            column: 34
          },
          end: {
            line: 58,
            column: 3
          }
        },
        line: 48
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 60,
            column: 2
          },
          end: {
            line: 60,
            column: 3
          }
        },
        loc: {
          start: {
            line: 60,
            column: 22
          },
          end: {
            line: 69,
            column: 3
          }
        },
        line: 60
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 71,
            column: 2
          },
          end: {
            line: 71,
            column: 3
          }
        },
        loc: {
          start: {
            line: 71,
            column: 45
          },
          end: {
            line: 75,
            column: 3
          }
        },
        line: 71
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 77,
            column: 2
          },
          end: {
            line: 77,
            column: 3
          }
        },
        loc: {
          start: {
            line: 77,
            column: 25
          },
          end: {
            line: 81,
            column: 3
          }
        },
        line: 77
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 83,
            column: 2
          },
          end: {
            line: 83,
            column: 3
          }
        },
        loc: {
          start: {
            line: 83,
            column: 21
          },
          end: {
            line: 89,
            column: 3
          }
        },
        line: 83
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 91,
            column: 2
          },
          end: {
            line: 91,
            column: 3
          }
        },
        loc: {
          start: {
            line: 91,
            column: 70
          },
          end: {
            line: 119,
            column: 3
          }
        },
        line: 91
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 121,
            column: 2
          },
          end: {
            line: 121,
            column: 3
          }
        },
        loc: {
          start: {
            line: 121,
            column: 16
          },
          end: {
            line: 229,
            column: 3
          }
        },
        line: 121
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 231,
            column: 2
          },
          end: {
            line: 231,
            column: 3
          }
        },
        loc: {
          start: {
            line: 231,
            column: 59
          },
          end: {
            line: 235,
            column: 3
          }
        },
        line: 231
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 237,
            column: 2
          },
          end: {
            line: 237,
            column: 3
          }
        },
        loc: {
          start: {
            line: 237,
            column: 19
          },
          end: {
            line: 253,
            column: 3
          }
        },
        line: 237
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 247,
            column: 34
          },
          end: {
            line: 247,
            column: 35
          }
        },
        loc: {
          start: {
            line: 247,
            column: 40
          },
          end: {
            line: 252,
            column: 5
          }
        },
        line: 247
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 255,
            column: 2
          },
          end: {
            line: 255,
            column: 3
          }
        },
        loc: {
          start: {
            line: 255,
            column: 34
          },
          end: {
            line: 257,
            column: 3
          }
        },
        line: 255
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 259,
            column: 2
          },
          end: {
            line: 259,
            column: 3
          }
        },
        loc: {
          start: {
            line: 259,
            column: 33
          },
          end: {
            line: 261,
            column: 3
          }
        },
        line: 259
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 263,
            column: 2
          },
          end: {
            line: 263,
            column: 3
          }
        },
        loc: {
          start: {
            line: 263,
            column: 38
          },
          end: {
            line: 265,
            column: 3
          }
        },
        line: 263
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 267,
            column: 2
          },
          end: {
            line: 267,
            column: 3
          }
        },
        loc: {
          start: {
            line: 267,
            column: 15
          },
          end: {
            line: 276,
            column: 3
          }
        },
        line: 267
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 271,
            column: 21
          },
          end: {
            line: 271,
            column: 22
          }
        },
        loc: {
          start: {
            line: 271,
            column: 26
          },
          end: {
            line: 273,
            column: 7
          }
        },
        line: 271
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 278,
            column: 2
          },
          end: {
            line: 278,
            column: 3
          }
        },
        loc: {
          start: {
            line: 278,
            column: 17
          },
          end: {
            line: 287,
            column: 3
          }
        },
        line: 278
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 282,
            column: 21
          },
          end: {
            line: 282,
            column: 22
          }
        },
        loc: {
          start: {
            line: 282,
            column: 26
          },
          end: {
            line: 284,
            column: 7
          }
        },
        line: 282
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 289,
            column: 2
          },
          end: {
            line: 289,
            column: 3
          }
        },
        loc: {
          start: {
            line: 289,
            column: 11
          },
          end: {
            line: 310,
            column: 3
          }
        },
        line: 289
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 66,
            column: 4
          },
          end: {
            line: 68,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 66,
            column: 4
          },
          end: {
            line: 68,
            column: 5
          }
        }, {
          start: {
            line: 66,
            column: 4
          },
          end: {
            line: 68,
            column: 5
          }
        }],
        line: 66
      },
      "1": {
        loc: {
          start: {
            line: 72,
            column: 4
          },
          end: {
            line: 74,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 72,
            column: 4
          },
          end: {
            line: 74,
            column: 5
          }
        }, {
          start: {
            line: 72,
            column: 4
          },
          end: {
            line: 74,
            column: 5
          }
        }],
        line: 72
      },
      "2": {
        loc: {
          start: {
            line: 72,
            column: 8
          },
          end: {
            line: 72,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 72,
            column: 8
          },
          end: {
            line: 72,
            column: 35
          }
        }, {
          start: {
            line: 72,
            column: 39
          },
          end: {
            line: 72,
            column: 66
          }
        }],
        line: 72
      },
      "3": {
        loc: {
          start: {
            line: 80,
            column: 4
          },
          end: {
            line: 80,
            column: 56
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 80,
            column: 4
          },
          end: {
            line: 80,
            column: 56
          }
        }, {
          start: {
            line: 80,
            column: 4
          },
          end: {
            line: 80,
            column: 56
          }
        }],
        line: 80
      },
      "4": {
        loc: {
          start: {
            line: 85,
            column: 4
          },
          end: {
            line: 87,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 85,
            column: 4
          },
          end: {
            line: 87,
            column: 5
          }
        }, {
          start: {
            line: 85,
            column: 4
          },
          end: {
            line: 87,
            column: 5
          }
        }],
        line: 85
      },
      "5": {
        loc: {
          start: {
            line: 85,
            column: 8
          },
          end: {
            line: 85,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 85,
            column: 8
          },
          end: {
            line: 85,
            column: 11
          }
        }, {
          start: {
            line: 85,
            column: 15
          },
          end: {
            line: 85,
            column: 28
          }
        }, {
          start: {
            line: 85,
            column: 32
          },
          end: {
            line: 85,
            column: 50
          }
        }],
        line: 85
      },
      "6": {
        loc: {
          start: {
            line: 92,
            column: 12
          },
          end: {
            line: 92,
            column: 24
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 92,
            column: 21
          },
          end: {
            line: 92,
            column: 24
          }
        }],
        line: 92
      },
      "7": {
        loc: {
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 114,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 114,
            column: 5
          }
        }, {
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 114,
            column: 5
          }
        }],
        line: 102
      },
      "8": {
        loc: {
          start: {
            line: 103,
            column: 6
          },
          end: {
            line: 113,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 103,
            column: 6
          },
          end: {
            line: 113,
            column: 7
          }
        }, {
          start: {
            line: 103,
            column: 6
          },
          end: {
            line: 113,
            column: 7
          }
        }],
        line: 103
      },
      "9": {
        loc: {
          start: {
            line: 103,
            column: 10
          },
          end: {
            line: 103,
            column: 30
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 103,
            column: 10
          },
          end: {
            line: 103,
            column: 23
          }
        }, {
          start: {
            line: 103,
            column: 27
          },
          end: {
            line: 103,
            column: 30
          }
        }],
        line: 103
      },
      "10": {
        loc: {
          start: {
            line: 107,
            column: 8
          },
          end: {
            line: 111,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 107,
            column: 8
          },
          end: {
            line: 111,
            column: 9
          }
        }, {
          start: {
            line: 107,
            column: 8
          },
          end: {
            line: 111,
            column: 9
          }
        }],
        line: 107
      },
      "11": {
        loc: {
          start: {
            line: 125,
            column: 4
          },
          end: {
            line: 125,
            column: 42
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 125,
            column: 4
          },
          end: {
            line: 125,
            column: 42
          }
        }, {
          start: {
            line: 125,
            column: 4
          },
          end: {
            line: 125,
            column: 42
          }
        }],
        line: 125
      },
      "12": {
        loc: {
          start: {
            line: 129,
            column: 4
          },
          end: {
            line: 129,
            column: 33
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 129,
            column: 4
          },
          end: {
            line: 129,
            column: 33
          }
        }, {
          start: {
            line: 129,
            column: 4
          },
          end: {
            line: 129,
            column: 33
          }
        }],
        line: 129
      },
      "13": {
        loc: {
          start: {
            line: 131,
            column: 4
          },
          end: {
            line: 131,
            column: 73
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 131,
            column: 4
          },
          end: {
            line: 131,
            column: 73
          }
        }, {
          start: {
            line: 131,
            column: 4
          },
          end: {
            line: 131,
            column: 73
          }
        }],
        line: 131
      },
      "14": {
        loc: {
          start: {
            line: 131,
            column: 8
          },
          end: {
            line: 131,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 131,
            column: 8
          },
          end: {
            line: 131,
            column: 16
          }
        }, {
          start: {
            line: 131,
            column: 20
          },
          end: {
            line: 131,
            column: 40
          }
        }, {
          start: {
            line: 131,
            column: 44
          },
          end: {
            line: 131,
            column: 65
          }
        }],
        line: 131
      },
      "15": {
        loc: {
          start: {
            line: 135,
            column: 26
          },
          end: {
            line: 135,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 135,
            column: 26
          },
          end: {
            line: 135,
            column: 44
          }
        }, {
          start: {
            line: 135,
            column: 48
          },
          end: {
            line: 135,
            column: 61
          }
        }],
        line: 135
      },
      "16": {
        loc: {
          start: {
            line: 138,
            column: 28
          },
          end: {
            line: 138,
            column: 94
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 138,
            column: 47
          },
          end: {
            line: 138,
            column: 87
          }
        }, {
          start: {
            line: 138,
            column: 90
          },
          end: {
            line: 138,
            column: 94
          }
        }],
        line: 138
      },
      "17": {
        loc: {
          start: {
            line: 141,
            column: 4
          },
          end: {
            line: 145,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 141,
            column: 4
          },
          end: {
            line: 145,
            column: 5
          }
        }, {
          start: {
            line: 141,
            column: 4
          },
          end: {
            line: 145,
            column: 5
          }
        }],
        line: 141
      },
      "18": {
        loc: {
          start: {
            line: 144,
            column: 6
          },
          end: {
            line: 144,
            column: 56
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 144,
            column: 6
          },
          end: {
            line: 144,
            column: 56
          }
        }, {
          start: {
            line: 144,
            column: 6
          },
          end: {
            line: 144,
            column: 56
          }
        }],
        line: 144
      },
      "19": {
        loc: {
          start: {
            line: 150,
            column: 14
          },
          end: {
            line: 150,
            column: 66
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 150,
            column: 47
          },
          end: {
            line: 150,
            column: 48
          }
        }, {
          start: {
            line: 150,
            column: 51
          },
          end: {
            line: 150,
            column: 66
          }
        }],
        line: 150
      },
      "20": {
        loc: {
          start: {
            line: 150,
            column: 14
          },
          end: {
            line: 150,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 150,
            column: 14
          },
          end: {
            line: 150,
            column: 20
          }
        }, {
          start: {
            line: 150,
            column: 24
          },
          end: {
            line: 150,
            column: 37
          }
        }, {
          start: {
            line: 150,
            column: 41
          },
          end: {
            line: 150,
            column: 44
          }
        }],
        line: 150
      },
      "21": {
        loc: {
          start: {
            line: 156,
            column: 4
          },
          end: {
            line: 184,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 156,
            column: 4
          },
          end: {
            line: 184,
            column: 5
          }
        }, {
          start: {
            line: 156,
            column: 4
          },
          end: {
            line: 184,
            column: 5
          }
        }],
        line: 156
      },
      "22": {
        loc: {
          start: {
            line: 156,
            column: 8
          },
          end: {
            line: 156,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 156,
            column: 8
          },
          end: {
            line: 156,
            column: 25
          }
        }, {
          start: {
            line: 156,
            column: 29
          },
          end: {
            line: 156,
            column: 46
          }
        }],
        line: 156
      },
      "23": {
        loc: {
          start: {
            line: 158,
            column: 6
          },
          end: {
            line: 161,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 158,
            column: 6
          },
          end: {
            line: 161,
            column: 7
          }
        }, {
          start: {
            line: 158,
            column: 6
          },
          end: {
            line: 161,
            column: 7
          }
        }],
        line: 158
      },
      "24": {
        loc: {
          start: {
            line: 162,
            column: 6
          },
          end: {
            line: 183,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 162,
            column: 6
          },
          end: {
            line: 183,
            column: 7
          }
        }, {
          start: {
            line: 162,
            column: 6
          },
          end: {
            line: 183,
            column: 7
          }
        }],
        line: 162
      },
      "25": {
        loc: {
          start: {
            line: 166,
            column: 13
          },
          end: {
            line: 183,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 166,
            column: 13
          },
          end: {
            line: 183,
            column: 7
          }
        }, {
          start: {
            line: 166,
            column: 13
          },
          end: {
            line: 183,
            column: 7
          }
        }],
        line: 166
      },
      "26": {
        loc: {
          start: {
            line: 166,
            column: 17
          },
          end: {
            line: 166,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 166,
            column: 17
          },
          end: {
            line: 166,
            column: 32
          }
        }, {
          start: {
            line: 166,
            column: 36
          },
          end: {
            line: 166,
            column: 70
          }
        }],
        line: 166
      },
      "27": {
        loc: {
          start: {
            line: 167,
            column: 8
          },
          end: {
            line: 169,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 167,
            column: 8
          },
          end: {
            line: 169,
            column: 9
          }
        }, {
          start: {
            line: 167,
            column: 8
          },
          end: {
            line: 169,
            column: 9
          }
        }],
        line: 167
      },
      "28": {
        loc: {
          start: {
            line: 170,
            column: 8
          },
          end: {
            line: 175,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 170,
            column: 8
          },
          end: {
            line: 175,
            column: 9
          }
        }, {
          start: {
            line: 170,
            column: 8
          },
          end: {
            line: 175,
            column: 9
          }
        }],
        line: 170
      },
      "29": {
        loc: {
          start: {
            line: 170,
            column: 14
          },
          end: {
            line: 170,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 170,
            column: 14
          },
          end: {
            line: 170,
            column: 20
          }
        }, {
          start: {
            line: 170,
            column: 24
          },
          end: {
            line: 170,
            column: 49
          }
        }],
        line: 170
      },
      "30": {
        loc: {
          start: {
            line: 176,
            column: 13
          },
          end: {
            line: 183,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 176,
            column: 13
          },
          end: {
            line: 183,
            column: 7
          }
        }, {
          start: {
            line: 176,
            column: 13
          },
          end: {
            line: 183,
            column: 7
          }
        }],
        line: 176
      },
      "31": {
        loc: {
          start: {
            line: 176,
            column: 17
          },
          end: {
            line: 176,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 176,
            column: 17
          },
          end: {
            line: 176,
            column: 35
          }
        }, {
          start: {
            line: 176,
            column: 39
          },
          end: {
            line: 176,
            column: 54
          }
        }],
        line: 176
      },
      "32": {
        loc: {
          start: {
            line: 179,
            column: 13
          },
          end: {
            line: 183,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 179,
            column: 13
          },
          end: {
            line: 183,
            column: 7
          }
        }, {
          start: {
            line: 179,
            column: 13
          },
          end: {
            line: 183,
            column: 7
          }
        }],
        line: 179
      },
      "33": {
        loc: {
          start: {
            line: 179,
            column: 17
          },
          end: {
            line: 179,
            column: 83
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 179,
            column: 17
          },
          end: {
            line: 179,
            column: 28
          }
        }, {
          start: {
            line: 179,
            column: 32
          },
          end: {
            line: 179,
            column: 47
          }
        }, {
          start: {
            line: 179,
            column: 51
          },
          end: {
            line: 179,
            column: 83
          }
        }],
        line: 179
      },
      "34": {
        loc: {
          start: {
            line: 186,
            column: 4
          },
          end: {
            line: 219,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 186,
            column: 4
          },
          end: {
            line: 219,
            column: 5
          }
        }, {
          start: {
            line: 186,
            column: 4
          },
          end: {
            line: 219,
            column: 5
          }
        }],
        line: 186
      },
      "35": {
        loc: {
          start: {
            line: 186,
            column: 8
          },
          end: {
            line: 186,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 186,
            column: 8
          },
          end: {
            line: 186,
            column: 28
          }
        }, {
          start: {
            line: 186,
            column: 32
          },
          end: {
            line: 186,
            column: 46
          }
        }],
        line: 186
      },
      "36": {
        loc: {
          start: {
            line: 189,
            column: 6
          },
          end: {
            line: 192,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 189,
            column: 6
          },
          end: {
            line: 192,
            column: 7
          }
        }, {
          start: {
            line: 189,
            column: 6
          },
          end: {
            line: 192,
            column: 7
          }
        }],
        line: 189
      },
      "37": {
        loc: {
          start: {
            line: 194,
            column: 6
          },
          end: {
            line: 218,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 194,
            column: 6
          },
          end: {
            line: 218,
            column: 7
          }
        }, {
          start: {
            line: 194,
            column: 6
          },
          end: {
            line: 218,
            column: 7
          }
        }],
        line: 194
      },
      "38": {
        loc: {
          start: {
            line: 198,
            column: 13
          },
          end: {
            line: 218,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 198,
            column: 13
          },
          end: {
            line: 218,
            column: 7
          }
        }, {
          start: {
            line: 198,
            column: 13
          },
          end: {
            line: 218,
            column: 7
          }
        }],
        line: 198
      },
      "39": {
        loc: {
          start: {
            line: 199,
            column: 8
          },
          end: {
            line: 200,
            column: 91
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 199,
            column: 8
          },
          end: {
            line: 199,
            column: 23
          }
        }, {
          start: {
            line: 200,
            column: 8
          },
          end: {
            line: 200,
            column: 91
          }
        }],
        line: 199
      },
      "40": {
        loc: {
          start: {
            line: 200,
            column: 9
          },
          end: {
            line: 200,
            column: 65
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 200,
            column: 30
          },
          end: {
            line: 200,
            column: 47
          }
        }, {
          start: {
            line: 200,
            column: 50
          },
          end: {
            line: 200,
            column: 65
          }
        }],
        line: 200
      },
      "41": {
        loc: {
          start: {
            line: 202,
            column: 8
          },
          end: {
            line: 204,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 202,
            column: 8
          },
          end: {
            line: 204,
            column: 9
          }
        }, {
          start: {
            line: 202,
            column: 8
          },
          end: {
            line: 204,
            column: 9
          }
        }],
        line: 202
      },
      "42": {
        loc: {
          start: {
            line: 205,
            column: 8
          },
          end: {
            line: 210,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 205,
            column: 8
          },
          end: {
            line: 210,
            column: 9
          }
        }, {
          start: {
            line: 205,
            column: 8
          },
          end: {
            line: 210,
            column: 9
          }
        }],
        line: 205
      },
      "43": {
        loc: {
          start: {
            line: 205,
            column: 14
          },
          end: {
            line: 205,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 205,
            column: 14
          },
          end: {
            line: 205,
            column: 20
          }
        }, {
          start: {
            line: 205,
            column: 24
          },
          end: {
            line: 205,
            column: 55
          }
        }],
        line: 205
      },
      "44": {
        loc: {
          start: {
            line: 211,
            column: 13
          },
          end: {
            line: 218,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 211,
            column: 13
          },
          end: {
            line: 218,
            column: 7
          }
        }, {
          start: {
            line: 211,
            column: 13
          },
          end: {
            line: 218,
            column: 7
          }
        }],
        line: 211
      },
      "45": {
        loc: {
          start: {
            line: 211,
            column: 17
          },
          end: {
            line: 211,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 211,
            column: 17
          },
          end: {
            line: 211,
            column: 35
          }
        }, {
          start: {
            line: 211,
            column: 39
          },
          end: {
            line: 211,
            column: 54
          }
        }],
        line: 211
      },
      "46": {
        loc: {
          start: {
            line: 214,
            column: 13
          },
          end: {
            line: 218,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 214,
            column: 13
          },
          end: {
            line: 218,
            column: 7
          }
        }, {
          start: {
            line: 214,
            column: 13
          },
          end: {
            line: 218,
            column: 7
          }
        }],
        line: 214
      },
      "47": {
        loc: {
          start: {
            line: 214,
            column: 17
          },
          end: {
            line: 214,
            column: 83
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 214,
            column: 17
          },
          end: {
            line: 214,
            column: 28
          }
        }, {
          start: {
            line: 214,
            column: 32
          },
          end: {
            line: 214,
            column: 47
          }
        }, {
          start: {
            line: 214,
            column: 51
          },
          end: {
            line: 214,
            column: 83
          }
        }],
        line: 214
      },
      "48": {
        loc: {
          start: {
            line: 221,
            column: 4
          },
          end: {
            line: 223,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 221,
            column: 4
          },
          end: {
            line: 223,
            column: 5
          }
        }, {
          start: {
            line: 221,
            column: 4
          },
          end: {
            line: 223,
            column: 5
          }
        }],
        line: 221
      },
      "49": {
        loc: {
          start: {
            line: 225,
            column: 4
          },
          end: {
            line: 228,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 225,
            column: 4
          },
          end: {
            line: 228,
            column: 5
          }
        }, {
          start: {
            line: 225,
            column: 4
          },
          end: {
            line: 228,
            column: 5
          }
        }],
        line: 225
      },
      "50": {
        loc: {
          start: {
            line: 233,
            column: 4
          },
          end: {
            line: 233,
            column: 54
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 233,
            column: 4
          },
          end: {
            line: 233,
            column: 54
          }
        }, {
          start: {
            line: 233,
            column: 4
          },
          end: {
            line: 233,
            column: 54
          }
        }],
        line: 233
      },
      "51": {
        loc: {
          start: {
            line: 234,
            column: 4
          },
          end: {
            line: 234,
            column: 54
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 234,
            column: 4
          },
          end: {
            line: 234,
            column: 54
          }
        }, {
          start: {
            line: 234,
            column: 4
          },
          end: {
            line: 234,
            column: 54
          }
        }],
        line: 234
      },
      "52": {
        loc: {
          start: {
            line: 239,
            column: 4
          },
          end: {
            line: 242,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 239,
            column: 4
          },
          end: {
            line: 242,
            column: 5
          }
        }, {
          start: {
            line: 239,
            column: 4
          },
          end: {
            line: 242,
            column: 5
          }
        }],
        line: 239
      },
      "53": {
        loc: {
          start: {
            line: 239,
            column: 8
          },
          end: {
            line: 239,
            column: 26
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 239,
            column: 8
          },
          end: {
            line: 239,
            column: 19
          }
        }, {
          start: {
            line: 239,
            column: 23
          },
          end: {
            line: 239,
            column: 26
          }
        }],
        line: 239
      },
      "54": {
        loc: {
          start: {
            line: 249,
            column: 6
          },
          end: {
            line: 251,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 249,
            column: 6
          },
          end: {
            line: 251,
            column: 7
          }
        }, {
          start: {
            line: 249,
            column: 6
          },
          end: {
            line: 251,
            column: 7
          }
        }],
        line: 249
      },
      "55": {
        loc: {
          start: {
            line: 268,
            column: 4
          },
          end: {
            line: 274,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 268,
            column: 4
          },
          end: {
            line: 274,
            column: 5
          }
        }, {
          start: {
            line: 268,
            column: 4
          },
          end: {
            line: 274,
            column: 5
          }
        }],
        line: 268
      },
      "56": {
        loc: {
          start: {
            line: 279,
            column: 4
          },
          end: {
            line: 285,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 279,
            column: 4
          },
          end: {
            line: 285,
            column: 5
          }
        }, {
          start: {
            line: 279,
            column: 4
          },
          end: {
            line: 285,
            column: 5
          }
        }],
        line: 279
      },
      "57": {
        loc: {
          start: {
            line: 296,
            column: 4
          },
          end: {
            line: 299,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 296,
            column: 4
          },
          end: {
            line: 299,
            column: 5
          }
        }, {
          start: {
            line: 296,
            column: 4
          },
          end: {
            line: 299,
            column: 5
          }
        }],
        line: 296
      },
      "58": {
        loc: {
          start: {
            line: 296,
            column: 8
          },
          end: {
            line: 296,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 296,
            column: 8
          },
          end: {
            line: 296,
            column: 14
          }
        }, {
          start: {
            line: 296,
            column: 18
          },
          end: {
            line: 296,
            column: 31
          }
        }, {
          start: {
            line: 296,
            column: 35
          },
          end: {
            line: 296,
            column: 38
          }
        }],
        line: 296
      },
      "59": {
        loc: {
          start: {
            line: 307,
            column: 9
          },
          end: {
            line: 307,
            column: 78
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 307,
            column: 9
          },
          end: {
            line: 307,
            column: 20
          }
        }, {
          start: {
            line: 307,
            column: 24
          },
          end: {
            line: 307,
            column: 78
          }
        }],
        line: 307
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0,
      "126": 0,
      "127": 0,
      "128": 0,
      "129": 0,
      "130": 0,
      "131": 0,
      "132": 0,
      "133": 0,
      "134": 0,
      "135": 0,
      "136": 0,
      "137": 0,
      "138": 0,
      "139": 0,
      "140": 0,
      "141": 0,
      "142": 0,
      "143": 0,
      "144": 0,
      "145": 0,
      "146": 0,
      "147": 0,
      "148": 0,
      "149": 0,
      "150": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0, 0],
      "6": [0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0],
      "42": [0, 0],
      "43": [0, 0],
      "44": [0, 0],
      "45": [0, 0],
      "46": [0, 0],
      "47": [0, 0, 0],
      "48": [0, 0],
      "49": [0, 0],
      "50": [0, 0],
      "51": [0, 0],
      "52": [0, 0],
      "53": [0, 0],
      "54": [0, 0],
      "55": [0, 0],
      "56": [0, 0],
      "57": [0, 0],
      "58": [0, 0, 0],
      "59": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _defineProperty from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Sticky/index.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { PureComponent } from '../component';
import { getParent } from '../utils/dom/element';
import { eventPassive } from '../utils/dom/detect';
import { defaultProps } from '../utils/defaultProps';
import { compose } from '../utils/func';
import { cssSupport, copyBoundingClientRect } from '../utils/dom/element';
import { docSize } from '../utils/dom/document';
import { consumer } from './context';
var events = (cov_1g45y1vbft.s[0]++, ['scroll', 'pageshow', 'load']);
var supportSticky = (cov_1g45y1vbft.s[1]++, cssSupport('position', 'sticky'));
var defaultZIndex = (cov_1g45y1vbft.s[2]++, 900);
var DefaultValue = (cov_1g45y1vbft.s[3]++, _objectSpread2(_objectSpread2({}, defaultProps), {}, {
  css: true
}));

var Sticky =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Sticky, _PureComponent);

  var _super = _createSuper2(Sticky);

  function Sticky(props) {
    var _this;

    _classCallCheck(this, Sticky);

    cov_1g45y1vbft.f[0]++;
    cov_1g45y1vbft.s[4]++;
    _this = _super.call(this, props);
    _this.style = void 0;
    _this.targetElement = void 0;
    _this.element = void 0;
    _this.scrollTimer = void 0;
    _this.placeholder = void 0;
    _this.origin = void 0;
    _this.locked = void 0;
    _this.scrollCount = void 0;
    cov_1g45y1vbft.s[5]++;
    _this.state = {};
    cov_1g45y1vbft.s[6]++;
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_this));
    cov_1g45y1vbft.s[7]++;
    _this.bindOrigin = _this.bindOrigin.bind(_assertThisInitialized(_this));
    cov_1g45y1vbft.s[8]++;
    _this.bindPlaceholder = _this.bindPlaceholder.bind(_assertThisInitialized(_this));
    cov_1g45y1vbft.s[9]++;
    _this.handlePosition = _this.handlePosition.bind(_assertThisInitialized(_this));
    cov_1g45y1vbft.s[10]++;
    _this.style = {};
    return _this;
  }

  _createClass(Sticky, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_1g45y1vbft.f[1]++;
      cov_1g45y1vbft.s[11]++;

      _get(_getPrototypeOf(Sticky.prototype), "componentDidMount", this).call(this);

      var _ref = (cov_1g45y1vbft.s[12]++, this.props),
          target = _ref.target;

      cov_1g45y1vbft.s[13]++;
      this.targetElement = getParent(this.element, target);
      cov_1g45y1vbft.s[14]++;
      this.handlePosition();
      cov_1g45y1vbft.s[15]++;

      if (!this.shouldUseCss) {
        cov_1g45y1vbft.b[0][0]++;
        cov_1g45y1vbft.s[16]++;
        this.bindScroll();
      } else {
        cov_1g45y1vbft.b[0][1]++;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      cov_1g45y1vbft.f[2]++;
      cov_1g45y1vbft.s[17]++;

      if ((cov_1g45y1vbft.b[2][0]++, !prevProps.needResetPostion) && (cov_1g45y1vbft.b[2][1]++, this.props.needResetPostion)) {
        cov_1g45y1vbft.b[1][0]++;
        cov_1g45y1vbft.s[18]++;
        this.setPosition();
      } else {
        cov_1g45y1vbft.b[1][1]++;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_1g45y1vbft.f[3]++;
      cov_1g45y1vbft.s[19]++;

      _get(_getPrototypeOf(Sticky.prototype), "componentWillUnmount", this).call(this);

      cov_1g45y1vbft.s[20]++;
      this.unbindScroll();
      cov_1g45y1vbft.s[21]++;

      if (this.scrollTimer) {
        cov_1g45y1vbft.b[3][0]++;
        cov_1g45y1vbft.s[22]++;
        clearTimeout(this.scrollTimer);
      } else {
        cov_1g45y1vbft.b[3][1]++;
      }
    }
  }, {
    key: "getStyle",
    value: function getStyle(mode, offset, left, width) {
      var _ref4;

      cov_1g45y1vbft.f[5]++;

      var _ref2 = (cov_1g45y1vbft.s[27]++, this.props.style),
          _ref2$zIndex = _ref2.zIndex,
          zIndex = _ref2$zIndex === void 0 ? (cov_1g45y1vbft.b[6][0]++, 900) : _ref2$zIndex;

      var _ref3 = (cov_1g45y1vbft.s[28]++, this.props),
          css = _ref3.css;

      var style = (cov_1g45y1vbft.s[29]++, (_ref4 = {
        position: 'fixed',
        left: left,
        width: width
      }, _defineProperty(_ref4, mode, offset), _defineProperty(_ref4, "zIndex", zIndex), _ref4));
      cov_1g45y1vbft.s[30]++;

      if (this.targetElement) {
        cov_1g45y1vbft.b[7][0]++;
        cov_1g45y1vbft.s[31]++;

        if ((cov_1g45y1vbft.b[9][0]++, supportSticky) && (cov_1g45y1vbft.b[9][1]++, css)) {
          cov_1g45y1vbft.b[8][0]++;
          cov_1g45y1vbft.s[32]++;
          style.position = 'sticky';
        } else {
          cov_1g45y1vbft.b[8][1]++;
          cov_1g45y1vbft.s[33]++;
          style.position = 'absolute';
          cov_1g45y1vbft.s[34]++;

          if (mode === 'top') {
            cov_1g45y1vbft.b[10][0]++;
            cov_1g45y1vbft.s[35]++;
            style.transform = "translateY(".concat(offset + this.targetElement.scrollTop, "px)");
          } else {
            cov_1g45y1vbft.b[10][1]++;
            cov_1g45y1vbft.s[36]++;
            style.transform = "translateY(".concat(this.targetElement.scrollTop, "px)");
          }

          cov_1g45y1vbft.s[37]++;
          delete style.left;
        }
      } else {
        cov_1g45y1vbft.b[7][1]++;
      }

      cov_1g45y1vbft.s[38]++;
      this.triggerChange(true, style);
      cov_1g45y1vbft.s[39]++;
      return style;
    }
  }, {
    key: "setPosition",
    value: function setPosition() {
      cov_1g45y1vbft.f[6]++;

      var _ref5 = (cov_1g45y1vbft.s[40]++, this.props),
          bottom = _ref5.bottom,
          top = _ref5.top,
          target = _ref5.target,
          css = _ref5.css,
          needResetPostion = _ref5.needResetPostion;

      var _ref6 = (cov_1g45y1vbft.s[41]++, this.state),
          mode = _ref6.mode,
          scrollWidth = _ref6.scrollWidth; // If it is a hidden element, the position will not be updated


      cov_1g45y1vbft.s[42]++;

      if (needResetPostion === false) {
        cov_1g45y1vbft.b[11][0]++;
        cov_1g45y1vbft.s[43]++;
        return;
      } else {
        cov_1g45y1vbft.b[11][1]++;
      }

      var selfRect = (cov_1g45y1vbft.s[44]++, copyBoundingClientRect(this.element));
      cov_1g45y1vbft.s[45]++;

      if (selfRect === null) {
        cov_1g45y1vbft.b[12][0]++;
        cov_1g45y1vbft.s[46]++;
        return;
      } else {
        cov_1g45y1vbft.b[12][1]++;
      } // If the element is hidden, the width and height will be 0


      cov_1g45y1vbft.s[47]++;

      if ((cov_1g45y1vbft.b[14][0]++, selfRect) && (cov_1g45y1vbft.b[14][1]++, selfRect.width === 0) && (cov_1g45y1vbft.b[14][2]++, selfRect.height === 0)) {
        cov_1g45y1vbft.b[13][0]++;
        cov_1g45y1vbft.s[48]++;
        return;
      } else {
        cov_1g45y1vbft.b[13][1]++;
      }

      var _ref7 = (cov_1g45y1vbft.s[49]++, getComputedStyle(this.element)),
          marginBottom = _ref7.marginBottom,
          marginTop = _ref7.marginTop;

      cov_1g45y1vbft.s[50]++;
      selfRect.height += parseFloat(marginBottom) + parseFloat(marginTop);
      var scrollElement = (cov_1g45y1vbft.s[51]++, (cov_1g45y1vbft.b[15][0]++, this.targetElement) || (cov_1g45y1vbft.b[15][1]++, document.body));
      var scrollRect = (cov_1g45y1vbft.s[52]++, scrollElement.getBoundingClientRect());
      var placeholderRect = (cov_1g45y1vbft.s[53]++, this.placeholder ? (cov_1g45y1vbft.b[16][0]++, copyBoundingClientRect(this.placeholder)) : (cov_1g45y1vbft.b[16][1]++, null));
      var viewHeight = (cov_1g45y1vbft.s[54]++, docSize.height);
      cov_1g45y1vbft.s[55]++;

      if (this.origin) {
        cov_1g45y1vbft.b[17][0]++;

        var _ref8 = (cov_1g45y1vbft.s[56]++, this.origin.getBoundingClientRect()),
            width = _ref8.width;

        cov_1g45y1vbft.s[57]++;
        selfRect.width = width;
        cov_1g45y1vbft.s[58]++;

        if (placeholderRect) {
          cov_1g45y1vbft.b[18][0]++;
          cov_1g45y1vbft.s[59]++;
          placeholderRect.width = width;
        } else {
          cov_1g45y1vbft.b[18][1]++;
        }
      } else {
        cov_1g45y1vbft.b[17][1]++;
      }

      var placeholderStyle = (cov_1g45y1vbft.s[60]++, {
        width: selfRect.width,
        // if target element is not null, set height to 0
        height: (cov_1g45y1vbft.b[20][0]++, target) && (cov_1g45y1vbft.b[20][1]++, supportSticky) && (cov_1g45y1vbft.b[20][2]++, css) ? (cov_1g45y1vbft.b[19][0]++, 0) : (cov_1g45y1vbft.b[19][1]++, selfRect.height)
      });
      var style;
      var placeholder;
      cov_1g45y1vbft.s[61]++;

      if ((cov_1g45y1vbft.b[22][0]++, top !== undefined) && (cov_1g45y1vbft.b[22][1]++, mode !== 'bottom')) {
        cov_1g45y1vbft.b[21][0]++;
        var limitTop = (cov_1g45y1vbft.s[62]++, top);
        cov_1g45y1vbft.s[63]++;

        if (this.targetElement) {
          cov_1g45y1vbft.b[23][0]++;

          var _ref9 = (cov_1g45y1vbft.s[64]++, getComputedStyle(scrollElement)),
              paddingTop = _ref9.paddingTop;

          cov_1g45y1vbft.s[65]++;
          limitTop += scrollRect.top + parseInt(paddingTop, 10);
        } else {
          cov_1g45y1vbft.b[23][1]++;
        }

        cov_1g45y1vbft.s[66]++;

        if (Math.ceil(selfRect.top) < limitTop) {
          cov_1g45y1vbft.b[24][0]++;
          cov_1g45y1vbft.s[67]++;
          this.setState({
            scrollWidth: scrollRect.width,
            mode: 'top'
          });
          cov_1g45y1vbft.s[68]++;
          style = this.getStyle('top', top, selfRect.left, selfRect.width);
          cov_1g45y1vbft.s[69]++;
          placeholder = placeholderStyle;
        } else {
          cov_1g45y1vbft.b[24][1]++;
          cov_1g45y1vbft.s[70]++;

          if ((cov_1g45y1vbft.b[26][0]++, placeholderRect) && (cov_1g45y1vbft.b[26][1]++, selfRect.top < placeholderRect.top)) {
            cov_1g45y1vbft.b[25][0]++;
            cov_1g45y1vbft.s[71]++;

            if (scrollRect.width !== selfRect.width) {
              cov_1g45y1vbft.b[27][0]++;
              cov_1g45y1vbft.s[72]++;
              style = this.getStyle('top', top, selfRect.left, scrollRect.width);
            } else {
              cov_1g45y1vbft.b[27][1]++;
            }

            cov_1g45y1vbft.s[73]++;

            if (!((cov_1g45y1vbft.b[29][0]++, target) && (cov_1g45y1vbft.b[29][1]++, selfRect.top === limitTop))) {
              cov_1g45y1vbft.b[28][0]++;
              cov_1g45y1vbft.s[74]++;
              this.setState({
                mode: ''
              });
              cov_1g45y1vbft.s[75]++;
              style = {};
              cov_1g45y1vbft.s[76]++;
              placeholder = null;
              cov_1g45y1vbft.s[77]++;
              this.triggerChange(false, style);
            } else {
              cov_1g45y1vbft.b[28][1]++;
            }
          } else {
            cov_1g45y1vbft.b[25][1]++;
            cov_1g45y1vbft.s[78]++;

            if ((cov_1g45y1vbft.b[31][0]++, this.targetElement) && (cov_1g45y1vbft.b[31][1]++, placeholderRect)) {
              cov_1g45y1vbft.b[30][0]++;
              cov_1g45y1vbft.s[79]++;
              style = this.getStyle('top', top, selfRect.left, selfRect.width);
              cov_1g45y1vbft.s[80]++;
              placeholder = placeholderStyle;
            } else {
              cov_1g45y1vbft.b[30][1]++;
              cov_1g45y1vbft.s[81]++;

              if ((cov_1g45y1vbft.b[33][0]++, scrollWidth) && (cov_1g45y1vbft.b[33][1]++, placeholderRect) && (cov_1g45y1vbft.b[33][2]++, scrollWidth !== scrollRect.width)) {
                cov_1g45y1vbft.b[32][0]++;
                cov_1g45y1vbft.s[82]++;
                this.setState({
                  scrollWidth: scrollRect.width,
                  mode: 'top'
                });
                cov_1g45y1vbft.s[83]++;
                style = this.getStyle('top', top, placeholderRect.left, placeholderRect.width);
                cov_1g45y1vbft.s[84]++;
                placeholder = placeholderStyle;
              } else {
                cov_1g45y1vbft.b[32][1]++;
              }
            }
          }
        }
      } else {
        cov_1g45y1vbft.b[21][1]++;
      }

      cov_1g45y1vbft.s[85]++;

      if ((cov_1g45y1vbft.b[35][0]++, bottom !== undefined) && (cov_1g45y1vbft.b[35][1]++, mode !== 'top')) {
        cov_1g45y1vbft.b[34][0]++;
        var limitBottom = (cov_1g45y1vbft.s[86]++, viewHeight - bottom);
        cov_1g45y1vbft.s[87]++;

        if (this.targetElement) {
          cov_1g45y1vbft.b[36][0]++;

          var _ref10 = (cov_1g45y1vbft.s[88]++, getComputedStyle(scrollElement)),
              paddingBottom = _ref10.paddingBottom;

          cov_1g45y1vbft.s[89]++;
          limitBottom = scrollRect.bottom - bottom - parseInt(paddingBottom, 10);
        } else {
          cov_1g45y1vbft.b[36][1]++;
        }

        cov_1g45y1vbft.s[90]++;

        if (selfRect.bottom > limitBottom) {
          cov_1g45y1vbft.b[37][0]++;
          cov_1g45y1vbft.s[91]++;
          this.setState({
            scrollWidth: scrollRect.width,
            mode: 'bottom'
          });
          cov_1g45y1vbft.s[92]++;
          style = this.getStyle('bottom', bottom, selfRect.left, selfRect.width);
          cov_1g45y1vbft.s[93]++;
          placeholder = placeholderStyle;
        } else {
          cov_1g45y1vbft.b[37][1]++;
          cov_1g45y1vbft.s[94]++;

          if ((cov_1g45y1vbft.b[39][0]++, placeholderRect) && (cov_1g45y1vbft.b[39][1]++, (this.targetElement ? (cov_1g45y1vbft.b[40][0]++, scrollRect.bottom) : (cov_1g45y1vbft.b[40][1]++, selfRect.bottom)) > placeholderRect.bottom)) {
            cov_1g45y1vbft.b[38][0]++;
            cov_1g45y1vbft.s[95]++;

            if (scrollRect.width !== selfRect.width) {
              cov_1g45y1vbft.b[41][0]++;
              cov_1g45y1vbft.s[96]++;
              style = this.getStyle('bottom', bottom, selfRect.left, scrollRect.width);
            } else {
              cov_1g45y1vbft.b[41][1]++;
            }

            cov_1g45y1vbft.s[97]++;

            if (!((cov_1g45y1vbft.b[43][0]++, target) && (cov_1g45y1vbft.b[43][1]++, selfRect.bottom === limitBottom))) {
              cov_1g45y1vbft.b[42][0]++;
              cov_1g45y1vbft.s[98]++;
              this.setState({
                mode: ''
              });
              cov_1g45y1vbft.s[99]++;
              style = {};
              cov_1g45y1vbft.s[100]++;
              placeholder = null;
              cov_1g45y1vbft.s[101]++;
              this.triggerChange(false, style);
            } else {
              cov_1g45y1vbft.b[42][1]++;
            }
          } else {
            cov_1g45y1vbft.b[38][1]++;
            cov_1g45y1vbft.s[102]++;

            if ((cov_1g45y1vbft.b[45][0]++, this.targetElement) && (cov_1g45y1vbft.b[45][1]++, placeholderRect)) {
              cov_1g45y1vbft.b[44][0]++;
              cov_1g45y1vbft.s[103]++;
              style = this.getStyle('bottom', bottom, selfRect.left, selfRect.width);
              cov_1g45y1vbft.s[104]++;
              placeholder = placeholderStyle;
            } else {
              cov_1g45y1vbft.b[44][1]++;
              cov_1g45y1vbft.s[105]++;

              if ((cov_1g45y1vbft.b[47][0]++, scrollWidth) && (cov_1g45y1vbft.b[47][1]++, placeholderRect) && (cov_1g45y1vbft.b[47][2]++, scrollWidth !== scrollRect.width)) {
                cov_1g45y1vbft.b[46][0]++;
                cov_1g45y1vbft.s[106]++;
                this.setState({
                  scrollWidth: scrollRect.width,
                  mode: 'bottom'
                });
                cov_1g45y1vbft.s[107]++;
                style = this.getStyle('bottom', bottom, placeholderRect.left, placeholderRect.width);
                cov_1g45y1vbft.s[108]++;
                placeholder = placeholderStyle;
              } else {
                cov_1g45y1vbft.b[46][1]++;
              }
            }
          }
        }
      } else {
        cov_1g45y1vbft.b[34][1]++;
      }

      cov_1g45y1vbft.s[109]++;

      if (placeholder !== undefined) {
        cov_1g45y1vbft.b[48][0]++;
        cov_1g45y1vbft.s[110]++;
        this.setState({
          placeholder: placeholder
        });
      } else {
        cov_1g45y1vbft.b[48][1]++;
      }

      cov_1g45y1vbft.s[111]++;

      if (style) {
        cov_1g45y1vbft.b[49][0]++;
        cov_1g45y1vbft.s[112]++;
        this.style = style;
        cov_1g45y1vbft.s[113]++;
        this.setState({
          style: style
        });
      } else {
        cov_1g45y1vbft.b[49][1]++;
      }
    }
  }, {
    key: "triggerChange",
    value: function triggerChange(flag, style) {
      cov_1g45y1vbft.f[7]++;

      var _ref11 = (cov_1g45y1vbft.s[114]++, this.props),
          onChange = _ref11.onChange;

      cov_1g45y1vbft.s[115]++;

      if (style.position === this.style.position) {
        cov_1g45y1vbft.b[50][0]++;
        cov_1g45y1vbft.s[116]++;
        return;
      } else {
        cov_1g45y1vbft.b[50][1]++;
      }

      cov_1g45y1vbft.s[117]++;

      if (typeof onChange === 'function') {
        cov_1g45y1vbft.b[51][0]++;
        cov_1g45y1vbft.s[118]++;
        onChange(flag);
      } else {
        cov_1g45y1vbft.b[51][1]++;
      }
    }
  }, {
    key: "handlePosition",
    value: function handlePosition() {
      var _this2 = this;

      cov_1g45y1vbft.f[8]++;

      var _ref12 = (cov_1g45y1vbft.s[119]++, this.props),
          css = _ref12.css;

      cov_1g45y1vbft.s[120]++;

      if ((cov_1g45y1vbft.b[53][0]++, this.locked) && (cov_1g45y1vbft.b[53][1]++, css)) {
        cov_1g45y1vbft.b[52][0]++;
        cov_1g45y1vbft.s[121]++;
        this.scrollCount += 1;
        cov_1g45y1vbft.s[122]++;
        return;
      } else {
        cov_1g45y1vbft.b[52][1]++;
      }

      cov_1g45y1vbft.s[123]++;
      this.locked = true;
      cov_1g45y1vbft.s[124]++;
      this.scrollCount = 0;
      cov_1g45y1vbft.s[125]++;
      this.setPosition();
      cov_1g45y1vbft.s[126]++;
      this.scrollTimer = setTimeout(function () {
        cov_1g45y1vbft.f[9]++;
        cov_1g45y1vbft.s[127]++;
        _this2.locked = false;
        cov_1g45y1vbft.s[128]++;

        if (_this2.scrollCount > 0) {
          cov_1g45y1vbft.b[54][0]++;
          cov_1g45y1vbft.s[129]++;

          _this2.handlePosition();
        } else {
          cov_1g45y1vbft.b[54][1]++;
        }
      }, 48);
    }
  }, {
    key: "bindElement",
    value: function bindElement(el) {
      cov_1g45y1vbft.f[10]++;
      cov_1g45y1vbft.s[130]++;
      this.element = el;
    }
  }, {
    key: "bindOrigin",
    value: function bindOrigin(el) {
      cov_1g45y1vbft.f[11]++;
      cov_1g45y1vbft.s[131]++;
      this.origin = el;
    }
  }, {
    key: "bindPlaceholder",
    value: function bindPlaceholder(el) {
      cov_1g45y1vbft.f[12]++;
      cov_1g45y1vbft.s[132]++;
      this.placeholder = el;
    }
  }, {
    key: "bindScroll",
    value: function bindScroll() {
      var _this3 = this;

      cov_1g45y1vbft.f[13]++;
      cov_1g45y1vbft.s[133]++;

      if (this.targetElement) {
        cov_1g45y1vbft.b[55][0]++;
        cov_1g45y1vbft.s[134]++;
        this.targetElement.addEventListener('scroll', this.handlePosition, eventPassive);
      } else {
        cov_1g45y1vbft.b[55][1]++;
        cov_1g45y1vbft.s[135]++;
        events.forEach(function (e) {
          cov_1g45y1vbft.f[14]++;
          cov_1g45y1vbft.s[136]++;
          window.addEventListener(e, _this3.handlePosition);
        });
      }

      cov_1g45y1vbft.s[137]++;
      window.addEventListener('resize', this.handlePosition);
    }
  }, {
    key: "unbindScroll",
    value: function unbindScroll() {
      var _this4 = this;

      cov_1g45y1vbft.f[15]++;
      cov_1g45y1vbft.s[138]++;

      if (this.targetElement) {
        cov_1g45y1vbft.b[56][0]++;
        cov_1g45y1vbft.s[139]++;
        this.targetElement.removeEventListener('scroll', this.handlePosition);
      } else {
        cov_1g45y1vbft.b[56][1]++;
        cov_1g45y1vbft.s[140]++;
        events.forEach(function (e) {
          cov_1g45y1vbft.f[16]++;
          cov_1g45y1vbft.s[141]++;
          window.removeEventListener(e, _this4.handlePosition);
        });
      }

      cov_1g45y1vbft.s[142]++;
      window.removeEventListener('resize', this.handlePosition);
    }
  }, {
    key: "render",
    value: function render() {
      cov_1g45y1vbft.f[17]++;

      var _ref13 = (cov_1g45y1vbft.s[143]++, this.props),
          children = _ref13.children,
          className = _ref13.className,
          target = _ref13.target,
          css = _ref13.css,
          top = _ref13.top,
          bottom = _ref13.bottom;

      var _ref14 = (cov_1g45y1vbft.s[144]++, this.state),
          placeholder = _ref14.placeholder;

      var outerStyle = (cov_1g45y1vbft.s[145]++, this.props.style);
      var innerStyle = (cov_1g45y1vbft.s[146]++, this.state.style);
      cov_1g45y1vbft.s[147]++;

      if ((cov_1g45y1vbft.b[58][0]++, target) && (cov_1g45y1vbft.b[58][1]++, supportSticky) && (cov_1g45y1vbft.b[58][2]++, css)) {
        cov_1g45y1vbft.b[57][0]++;
        cov_1g45y1vbft.s[148]++;
        outerStyle = Object.assign({
          zIndex: defaultZIndex
        }, outerStyle, {
          position: 'sticky',
          top: top,
          bottom: bottom
        });
        cov_1g45y1vbft.s[149]++;
        innerStyle = {};
      } else {
        cov_1g45y1vbft.b[57][1]++;
      }

      cov_1g45y1vbft.s[150]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          style: outerStyle,
          className: className,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 302,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement("div", {
          ref: this.bindElement,
          style: Object.assign({}, innerStyle, {
            display: 'flow-root'
          }),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 303,
            columnNumber: 9
          }
        }, children),
        /*#__PURE__*/
        React.createElement("div", {
          ref: this.bindOrigin,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 306,
            columnNumber: 9
          }
        }), (cov_1g45y1vbft.b[59][0]++, placeholder) && (cov_1g45y1vbft.b[59][1]++,
        /*#__PURE__*/
        React.createElement("div", {
          ref: this.bindPlaceholder,
          style: placeholder,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 307,
            columnNumber: 25
          }
        })))
      );
    }
  }, {
    key: "shouldUseCss",
    get: function get() {
      cov_1g45y1vbft.f[4]++;

      var _ref15 = (cov_1g45y1vbft.s[23]++, this.props),
          css = _ref15.css;

      cov_1g45y1vbft.s[24]++;

      if ((cov_1g45y1vbft.b[5][0]++, css) && (cov_1g45y1vbft.b[5][1]++, supportSticky) && (cov_1g45y1vbft.b[5][2]++, this.targetElement)) {
        cov_1g45y1vbft.b[4][0]++;
        cov_1g45y1vbft.s[25]++;
        return true;
      } else {
        cov_1g45y1vbft.b[4][1]++;
      }

      cov_1g45y1vbft.s[26]++;
      return false;
    }
  }]);

  return Sticky;
}(PureComponent);

Sticky.displayName = 'ShineoutSticky';
Sticky.defaultProps = DefaultValue;
export default compose(consumer)(Sticky);